export default __webpack_public_path__ + "static/media/11-SnowglobeDonut.8c85e76f.png";